// extracted by mini-css-extract-plugin
export default {"root":"IconDiscount_root__SJGIK"};